import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { inject } from 'mobx-react'
import { AuthStore } from './types'
import { RouteProps } from 'react-router'

type RestrictedRouteProps = {
  requiredPermission: string
} & RouteProps

type InjectedProps = {
  authStore: AuthStore
}

@inject('authStore')
class RestrictedRoute extends React.PureComponent<RestrictedRouteProps> {
  get injected() {
    return this.props as RestrictedRouteProps & InjectedProps & RouteProps
  }

  render() {
    const { requiredPermission, authStore, component, ...routeProps } = this.injected
    const Component = component as React.ComponentClass
    return (
      <Route
        {...routeProps}
        render={(props) =>
          authStore.userHasPermission(requiredPermission) ? <Component {...props} /> : <Redirect to='/' />
        }
      />
    )
  }
}

export default RestrictedRoute
